module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/title-award.8ce97f7d.png";